// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BookingIdCard-bookingIdBoxTopRadius-C2UfW {
    border-radius: var(--radius-3) var(--radius-3) 0 0;
}

.BookingIdCard-bookingIdBoxBottomRadius-Sq5Rk {
    border-radius: 0 0 var(--radius-3) var(--radius-3);
}

.BookingIdCard-bookingIdCardWrapper-zUEPP {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 18px;
    grid-gap: 18px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.BookingIdCard-bookingIdInfoIdBox-VIXvt {
    font-size: 16px;
    line-height: 26px;
    font-weight: 700;
    padding: 3px 12px;
    background: var(--opt-bg);
    border-radius: var(--radius-5);
    color: var(--common-primary-black-foreground);
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/BookingIdCard/BookingIdCard.css"],"names":[],"mappings":"AAAA;IACI,kDAAkD;AACtD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,8BAA8B;IAC9B,6CAA6C;IAC7C,kBAAkB;AACtB","sourcesContent":[".bookingIdBoxTopRadius {\n    border-radius: var(--radius-3) var(--radius-3) 0 0;\n}\n\n.bookingIdBoxBottomRadius {\n    border-radius: 0 0 var(--radius-3) var(--radius-3);\n}\n\n.bookingIdCardWrapper {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 18px;\n    grid-gap: 18px;\n    flex-wrap: wrap;\n}\n\n.bookingIdInfoIdBox {\n    font-size: 16px;\n    line-height: 26px;\n    font-weight: 700;\n    padding: 3px 12px;\n    background: var(--opt-bg);\n    border-radius: var(--radius-5);\n    color: var(--common-primary-black-foreground);\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bookingIdBoxTopRadius": `BookingIdCard-bookingIdBoxTopRadius-C2UfW`,
	"bookingIdBoxBottomRadius": `BookingIdCard-bookingIdBoxBottomRadius-Sq5Rk`,
	"bookingIdCardWrapper": `BookingIdCard-bookingIdCardWrapper-zUEPP`,
	"bookingIdInfoIdBox": `BookingIdCard-bookingIdInfoIdBox-VIXvt`
};
module.exports = ___CSS_LOADER_EXPORT___;
